// client/plugins/ObsidianLinkPlugin/helper/parseTextToLink.ts
var findTextNodesWithPositions = (doc) => {
  const node = doc;
  const result = [];
  const findPositions = (node2, pos = 0) => {
    if (node2.type.name === "text") {
      result.push({ node: node2, offset: pos });
    }
    node2.forEach((child, offset) => {
      findPositions(child, pos + offset + 1);
    });
  };
  findPositions(node);
  return result;
};
var parseTextToLinkNode = ({ view }) => {
  const transaction = view.state.tr;
  if (transaction.selection.from !== transaction.selection.to)
    return false;
  const { state } = view;
  const textNodesWithOffset = findTextNodesWithPositions(transaction.doc);
  for (const textNodeWithOffset of textNodesWithOffset) {
    const textNode = textNodeWithOffset.node;
    const offset = textNodeWithOffset.offset;
    const text = textNode.text;
    if (text === void 0)
      continue;
    let isOpen = false;
    let openedAt = null;
    for (let i = 1; i < text.length - 1; i++) {
      const prevChar = text[i - 1];
      const currChar = text[i];
      const nextChar = text[i + 1];
      if (!prevChar || !currChar || !nextChar)
        continue;
      const isBracketsOpening = prevChar === "[" && currChar === "[";
      if (isBracketsOpening) {
        isOpen = true;
        openedAt = i - 1;
        continue;
      }
      if (!isOpen || !openedAt && typeof openedAt !== "number")
        continue;
      const isBracketsClosing = currChar === "]" && nextChar === "]";
      if (!isBracketsClosing)
        continue;
      const { from, to } = transaction.selection;
      const transformText = text.substring(openedAt, i + 2);
      const textNodeFrom = offset + openedAt - 1;
      const textNodeTo = offset + openedAt + transformText.length - 1;
      if (from >= textNodeFrom && to <= textNodeTo) {
        isOpen = false;
        openedAt = null;
        continue;
      }
      const strippedTransformText = transformText.replace("[[", "").replace("]]", "");
      const strippedTransformTextParts = strippedTransformText.split("|");
      const linkMark = state.schema.marks.link?.create({ href: strippedTransformTextParts[0], target: "_self" });
      if (!linkMark)
        throw new Error("mark link not found");
      const linkText = strippedTransformTextParts[1] ? strippedTransformTextParts[1] : strippedTransformTextParts[0] ? strippedTransformTextParts[0] : null;
      if (!linkText)
        continue;
      const newLinkNode = state.schema.text(linkText, [linkMark]);
      view.dispatch(transaction.replaceWith(textNodeFrom, textNodeTo, newLinkNode));
      return true;
    }
  }
  return false;
};
export {
  findTextNodesWithPositions,
  parseTextToLinkNode
};
